import { render, staticRenderFns } from "./editBarInfo.vue?vue&type=template&id=63861340&scoped=true&"
import script from "./editBarInfo.vue?vue&type=script&lang=js&"
export * from "./editBarInfo.vue?vue&type=script&lang=js&"
import style0 from "./editBarInfo.vue?vue&type=style&index=0&id=63861340&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63861340",
  null
  
)

component.options.__file = "editBarInfo.vue"
export default component.exports